










































import { Component, Vue, Prop } from 'vue-property-decorator'

import dayjs from '@/dayjs'

interface PreviewImage {
  url: string
}

@Component
export default class ReviewPreview extends Vue {
  @Prop({ default: 0 }) rating!: number
  @Prop({ default: '' }) title!: string
  @Prop({ default: '' }) body!: string
  @Prop({ default: '' }) displayName!: string
  @Prop({ default: '' }) groupSize!: string
  @Prop({ default: () => [] }) images!: PreviewImage[]
  @Prop({ default: true }) showHeader!: boolean

  get formattedDate(): string {
    return dayjs().format('DD/MM/YYYY HH:mm')
  }

  get groupSizeLabel(): string {
    if (!this.groupSize) {
      return ''
    }
    if (this.groupSize === 'Solo') {
      return ', Solo'
    }
    return `, Travelled with ${this.groupSize}`
  }
}
